import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Checkbox } from '../Form';
import Item from './Item';

import { media } from '../../styles/media';

const Root = styled.li`
  font-family: ${props => props.theme.font.brand.secondary};
  font-size: 15px;
  line-height: 18px;

  color: ${props => props.theme.color.brand.accent};

  ${media.tablet`
    width: 50%;
    flex-shrink: 0;
  `};

  ${media.desktop`
    width: auto;
    flex: 1 1 auto;
  `};
`;

const Content = styled.ul`
  margin: ${props => props.theme.layout.gutter / 4}px 0
    ${props => props.theme.layout.gutter}px
    ${props => props.theme.layout.gutter}px;

  ${media.desktop`
    margin: ${props => props.theme.layout.gutter / 2}px 0 0 ${props =>
    props.theme.layout.gutter}px;
  `};
`;

class Category extends PureComponent {
  renderItem = ({ id, label }, index) => {
    const { onFilterChange, filters } = this.props;
    const category = this.props.id;

    return (
      <Item
        key={index}
        id={id}
        category={category}
        label={label}
        onChange={onFilterChange}
        checked={filters[category][id]}
      />
    );
  };

  renderItems = items => {
    return items.map(this.renderItem);
  };

  render() {
    const { id, label, onCategoryChange, items, checked } = this.props;

    return (
      <Root>
        <Checkbox name={id} onChange={onCategoryChange} checked={checked}>
          {label}
        </Checkbox>
        {items && <Content>{this.renderItems(items)}</Content>}
      </Root>
    );
  }
}

Category.propTypes = {
  id: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  onFilterChange: PropTypes.func,
  onCategoryChange: PropTypes.func.isRequired,
  items: PropTypes.array,
  filters: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired
};

export default Category;
